/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * String helper, provide utility methods to work with strings
 */
export const stringHelper = {
  /**
   * Returns a formatted string using the specified format and arguments.
   * If an array is passed as the only argument, the elements of this collection are used as arguments for the formatting.
   *
   * @example
   *
   * ```ts
   *  format('Message: {0}, {1}', 'test', 10)
   *  // Message: test, 10
   *
   *  format('Message: {0}, {1}', ['test', 10])
   *  // Message: test, 10
   * ```
   *
   * @param {string}  input The input string to format.
   * @param  {...any} args  List of arguments which are included into the result string
   *
   * @returns {string} The formatted result string.
   */
  format(input, ...args) {
    if (args.length === 1 && Array.isArray(args[0])) {
      args = args[0];
    }

    return input.replace(/{(\d+)}/g, (match, index) => (Object.hasOwn(args, index) ? args[index] : match));
  },

  /**
   * Creates a base64 encoded ASCII string from an input string
   *
   * @param {string} input The input string
   *
   * @returns {string} An encoded ASCII string
   */
  encodeBase64(input) {
    return window.btoa(input);
  },

  /**
   * Decodes a string of data which has been encoded using Base64 encoding
   *
   * @param {string} input The encoded input string
   *
   * @returns {string} An ASCII string containing decoded data from encoded input.
   */
  decodeBase64(input) {
    return window.atob(input);
  },
};
